import React, { useRef, useState } from 'react';
import AttachmentDropzone from './AttachtmenDropzone';
import DescriptionTinyEditor from './DescriptionTinyEditor';
import UploadHubModalAttach from 'components/UploadHub/UploadHubModalAttach';

const Description = (props) => {
  const { sectionValues, createdFromTheApi } = props;
  const { fields } = sectionValues;
  const [showAttachModal, setShowAttachModal] = useState(false);
  const [attachTarget, setAttachTarget] = useState(null);

  const handleAttach = (files) => {
    if (!attachTarget || !files?.length) return;
    const { value, setValue } = attachTarget;
    const savedFiles = value?.savedFiles ?? [];
    setValue({
      ...value,
      savedFiles: savedFiles.concat(files.map(({ url, fileName }) => ({ url, name: fileName }))),
    });
  };

  const buttonRef = useRef(null);

  return (
    <>
      {createdFromTheApi && (
        <div className='bg-light-red influence-creation_section'>
          <h4 className='title-h5-bold'>Disclaimer</h4>
          <p className='d-flex align-items-center mb-0'>
            The text below was written by PolicyMogul’s AI assistant. This feature is in Beta and output may contain
            factual errors. You can use it verbatim, but we suggest you read it carefully and consider making edits to
            ensure it is accurate and reflects your views.
          </p>
        </div>
      )}
      <div className='influence-creation_section influence-description'>
        {fields.map((item, index) => {
          const { title, value, setValue, name, required, subtext } = item;
          return (
            <div className='description-value' key={`description-value-${index}`}>
              <div className='flex-centered justify-content-between mb-2'>
                <h3 className='title-h5-m-bold mb-0'>
                  {title}
                  {!required && <span> (optional)</span>}
                </h3>
                {name === 'attachments' && (
                  <button
                    className='general-button circle-button circle-button-36 hovered-button'
                    data-tooltip-id='general-tooltip'
                    data-tooltip-content={'Attach from files'}
                    ref={buttonRef}
                    onClick={() => {
                      buttonRef.current.blur();
                      setAttachTarget({ value, setValue });
                      setShowAttachModal(true);
                    }}
                  >
                    <span className='icon-upload paragraph-p3 d-inline-block-centered centered-4' />
                  </button>
                )}
              </div>
              <p className='paragraph-p2 main-light-text mb-3'>{subtext}</p>
              {name !== 'attachments' && (
                <>
                  <DescriptionTinyEditor name={name} value={value} setValue={setValue} index={index} />
                </>
              )}
              {name === 'attachments' && <AttachmentDropzone value={value} setValue={setValue} />}
            </div>
          );
        })}
      </div>
      <UploadHubModalAttach
        openState={{ isOpen: showAttachModal, setIsOpen: setShowAttachModal }}
        onAttach={handleAttach}
      />
    </>
  );
};

export default Description;
